import { render } from "./custom-toggle.vue?vue&type=template&id=ab6c9e40&lang=pug"
import script from "./custom-toggle.vue?vue&type=script&lang=js"
export * from "./custom-toggle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__